import { useMutation } from '@tanstack/react-query';
import { queryClient } from 'src/components/queryProvider';
import { queryKeys, requestCCApi } from 'src/utils';

export const useDeleteComponentTag = () => {
  return useMutation({
    mutationFn: deleteComponentTag,
    onSuccess: () => {
      queryClient.invalidateQueries(queryKeys.componentTags.invalidateAll());
      queryClient.invalidateQueries(
        queryKeys.viewComponentTagWithComponentCount.invalidateAll(),
      );
    },
  });
};

const deleteComponentTag = async (tagId: number) => {
  const response = await requestCCApi({
    url: `/componentTags/${tagId}`,
    method: 'DELETE',
  });

  return response;
};
